module.exports = __webpack_public_path__ + "dddbea36.jpg";